// Normalize the user's decimal notation without floating point or rounding.
export function normalizeRuleAmount(value: string): string {
  const match = /^(\d{1,12})(?:[.,](\d{1,2}))?$/.exec(value.trim());
  if (!match)
    throw new Error(
      'Importe: escribe un valor positivo, sin separadores de miles y con hasta dos decimales (por ejemplo, 5 o 5,50).',
    );
  const integer = match[1]!.replace(/^0+(?=\d)/, '');
  const result = integer + '.' + (match[2] ?? '').padEnd(2, '0');
  if (result === '0.00') throw new Error('El importe debe ser mayor que cero.');
  return result;
}
